import React from 'react';
import TopBar from './TopBar';
import { useTheme } from '../hooks/useTheme';
import LineActiveCall from './LineActiveCall';

interface Breadcrumb {
    title: string;
    onClick?: () => void;
}

interface LayoutWithTopBarProps {
    onClickPrevArrow?: () => void;
    children: React.ReactNode;
    breadcrumbs?: Breadcrumb[];
    topBarChildren?: React.ReactNode;
    topBarEndPart?: React.ReactNode;
    hideLineActiveCall?: boolean;
}

export const LayoutWithTopBar: React.FC<LayoutWithTopBarProps> = ({
  onClickPrevArrow,
  children,
  breadcrumbs,
  topBarChildren,
  topBarEndPart,
  hideLineActiveCall = false
}) => {
    const {isMobile} = useTheme();

    return (
        <div className={`flex-grow flex flex-col bg-brand-bg-3 h-full overflow-hidden ${isMobile ? '' : 'rounded-3xl'}`}>
            {!hideLineActiveCall && <LineActiveCall />}
            <TopBar
                onClickPrevArrow={onClickPrevArrow}
                endPart={topBarEndPart}
                className={isMobile ? "px-2" : "px-4"}
            >
                {
                    breadcrumbs && <div className="flex-grow flex flex-row gap-2">
                        {
                            breadcrumbs.map((breadcrumb, index) => {
                                const isLast = index === breadcrumbs.length - 1;

                                return <div 
                                    className={`flex items-center gap-2 ${isLast ? 'text-brand-color' : 'text-brand-color-2'}`} 
                                    key={index}
                                >
                                    <h1 
                                        className={`font-semibold text-center ${breadcrumb.onClick && 'cursor-pointer'}`}
                                        onClick={breadcrumb.onClick}
                                    >
                                        {breadcrumb.title}
                                    </h1>
                                    {!isLast && <div>/</div>}
                                </div>
                            })
                        }
                    </div>
                }
                {
                    topBarChildren
                }
            </TopBar>
            <div className={`flex-grow overflow-y-auto flex flex-col ${/*isMobile ? "mt-[80px]" :*/ ""}`}>
                {children}
            </div>
        </div>
    );
}